import React from 'react'
import ReactDOM from 'react-dom/client'
import { PostHogProvider } from '@posthog/react'
import './index.css'
import './globals.css'
import App from './App'
import { POSTHOG_OPTIONS, POSTHOG_PROJECT_TOKEN } from './posthog'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  POSTHOG_PROJECT_TOKEN ? (
    <PostHogProvider apiKey={POSTHOG_PROJECT_TOKEN} options={POSTHOG_OPTIONS}>
      <App />
    </PostHogProvider>
  ) : (
    <App />
  )
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
